<div class="w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">recharge internet {{ step }}/2</div>
</div>

@if (step === 1 && line.status.toLowerCase() !== 'active') {
    <div class="mt-5">
        <div class="w-100 text-center proc-buttons">
            <div>Pour recharger Internet, La ligne doit être active.</div>
        </div>
    </div>
}

@if (step === 1 && line.status.toLowerCase() == 'active' && availableDataServicesList.length == 0) {
    <div class="mt-5">
        <div class="w-100 text-center proc-buttons">
            <div class="bold-red-text">La liste des recharges est vide pour ce numéro <strong
                    class="bold-red-text">{{ line.phoneNumber }}</strong>.
            </div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            </div>
        </div>
    </div>
}

@if (step === 1 && line.status.toLowerCase() == 'active' && availableDataServicesList.length > 0) {
    <div>
        <div class="col-12">
            <div class="bold-label-text pb-3">Ligne : <span class="blue-text">{{ line.phoneNumber }}</span></div>
        </div>
        <div class="form-group radio-group ">
            @for (availableData of availableDataServicesList; track availableData; let index = $index) {
                <div class="group-options">
                    <input
                            type="radio"
                            [id]="'data' + index"
                            name="activate"
                            [value]="availableData.id"
                            [checked]="selectedRecharge && selectedRecharge.id == availableData.id"
                            (click)="choiceData($event)"
                    >
                    <label [for]="'data' + index">{{ availableData.label }} :&nbsp;</label>
                    <span>{{ displayPrice(availableData.price_ht) }}</span>
                </div>
            }
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="checkDataChoice()">Suivant<span></span>
                </button>
            </div>
        </div>
    </div>
}

@if (step === 2) {
    <div>
        <div class="col-12">
            <div class="bold-text pb-3 mt-5 text-center"> Etes-vous sûr d'éffectuer la
                <strong>{{ selectedRecharge.label }}</strong> pour ce numéro <strong>{{ line.phoneNumber }}</strong> ?
            </div>
        </div>
        <div class="row w-100 pt-3 text-center">
            <div class="col-12 w-100 cta_container">
                <button type="button" class="cta_cancel column" (click)="setStep(1)">Retour<span></span></button>
                <button type="button" class="cta_btn level_2 column" (click)="submit()">valider<span></span></button>
            </div>
        </div>
    </div>
}

